
export default {
  props: {
    suggestion: {type: Object, required: true},
    selected: {type: Boolean, default: false},
    checkIcon: {type: Boolean, default: false},
  },
  computed: {
    link() {
      if (this.suggestion.linkedin_id) {
        return `linkedin: ${this.suggestion.linkedin_id}`
      }

      return undefined
    },
    c_name() {
      if (this.suggestion.name) return this.suggestion.name
      return `${this.suggestion.first_name} ${this.suggestion.last_name}`
    }
  }
}
